import React, { Component } from 'react';


class Wrapper extends Component{
    render(){
        const styles = {
            margin: "auto",
            width: "87%",
            height: "72vh",
            borderRadius: "5px",
            shadowColor: "#000",
           
            fontWeight: "400",
            fontSize: "12px",
            boderWidth: "1px",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            
        }
        return(
            <section>
                <div style={styles}>
                {this.props.children}
                </div>
            </section>
        )
    }
};
 
export { Wrapper };


// WEBPACK FOOTER //
// ./src/components/common/Wrapper.js